import {durationText, durationUnit} from '../../utils/appHelper';

export const createStripePurchaseCard = (data, is_subscription) => {
  let is_single = true;
  if($.type(data) == 'array'){
    is_single = false;
  }
  let paymentDetails = '';
  let plans_field = '';

  if(is_single){
    if(is_subscription){
      paymentDetails = `
        <p class="purchase-card-title">SUBCRIPTION</p>
        <p class="purchase-card-video-title" style="margin-bottom: 0;padding: 0px;">${data.title}</p>
        <p class="purchase-card-video-title" style="margin-bottom: 0;padding-bottom: 0;">Subscribe now to watch this content</p>
        ${data.trial_in ? '<p class="purchase-card-video-title" style="margin-bottom: 0;padding-bottom: 0;">Free Trial: '+durationText(data.trial_in)+'</p>' : ''}
        <p class="purchase-card-price price-p" style="text-align:center;">
          $${data?.price} 
          <span class="purchase-card-video-title" style="color: black;padding: 0px;">(Per ${durationUnit(data.expires_in)})<span>
        </p>
      `;
    }
    else{
      paymentDetails = `
        <p class="purchase-card-title">PAY PER VIEW</p>
        <p class="purchase-card-video-title">${data.title}</p>
        <p class="purchase-card-price" style="text-align:center;padding-top:0px">$${data?.price}</p>
      `;
    }

  }
  else{
    paymentDetails = `<p class="purchase-card-title">SUBCRIPTION</p>
      <p class="purchase-card-video-title">Subscribe now to watch this content</p>
    `;
    plans_field = `<div class="form-row" style="margin-top:10px">
    <label for="Plan">Plan</label>
    <select name="plan_id" style="width:100%" id="plan_value">
      <option value="" selected>Choose Plan</option>`;

    data.forEach(function (val) {
      plans_field +=`<option value="${val.uuid}">${val.title} ($${val.price} Per ${durationUnit(val.expires_in)})</option>`
    });

    plans_field += `</select></div>`;
  }


  return `
    <div class="modal" id="stripePurchaseCard" style="display: flex;align-items: center; justify-content: center;">
      <style>
        label{
          font-size: 15px;
          margin-bottom: 0px;
        }
        #card-element {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
        }
        
        .StripeElement {
          width: 100%;
          padding: 10px;
          font-size: 16px;
          line-height: 24px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }
        
        .StripeElement--focus {
          border-color: #000;
        }
        #coupon_code, #email, #first_name, #last_name, #plan_value{
          font-size: 16px;
          line-height: 24px;
          border: 1px solid #ccc;
          border-radius: 4px;
          padding: 10px;
        }
        .purchase-card-buy-now{
          margin-bottom:50px;
        }
        #stripe-card-errors{
          margin-top: 25px;
          text-align: left;
          color: red;
          font-size: 16px;
          margin-bottom: 10px;
        }
        .purchase-card-price{
          padding: 10px;
          margin-bottom: 0px;
          font-size: 42px;
        }
        .coupon_apply_btn {
          outline: none;
          border: none;
          background: black;
          color: white;
          font-size: 18px;
          font-weight: 400;
          // margin-top: 50px;
          padding: 9px 20px;
        }
      </style>

      <div class="purchase-card" style="max-width: 500px">
        <span id="closeStripePurchaseCard" class="close-purchase-card">&times;</span>
        <div class="price_details">${paymentDetails}</div>
        <div class="purchase-card-buy-now-container">
          
          <form id="stripe-payment-form" style="width:100%;padding: 0px 30px;text-align:center;">
            <div class="coupon_field"></div>

            <div class="plans_dropdown">${plans_field}</div>
            
            <div class="card_fields"></div>
            <div class="form-row" style="margin-top:10px">
              <label for="email">Email</label>
              <input type="email" id="email" name="email" style="width:100%" required>
            </div>

            <div class="form-row" style="text-align: left;margin-top: 10px;">
              <div class="col" style="padding-left:0px">
                <label for="first_name">First Name</label>
                <input type="first_name" id="first_name" name="first_name" style="width:100%" required>
              </div>
              <div class="col" style="padding-right:0px">
                <label for="last_name">Last Name</label>
                <input type="last_name" id="last_name" name="last_name" style="width:100%" required>
              </div>
            </div>
            
            <div id="stripe-card-errors" role="alert"></div>
          
            <button id="stripe-submit-payment" class="purchase-card-buy-now">Submit Payment</button>

            <p style="text-align: center;font-size: 16px;margin-bottom: 30px;">Already have account? <a href="/sign-in" style="font-weight: bold;text-decoration: underline;font-size: 16px;">Login</a></p>

          </form>

        </div>
      </div>
    </div>
    `;
};



export const addCardFeilds = (data, is_subscription) => {
  $('.coupon_field').html(`<div class="form-row" style="text-align: left">
  <div class="col" style="padding-left:0px">
    <input type="coupon_code" id="coupon_code" name="coupon_code" style="width:100%" required, placeholder="Coupon Code">
  </div>
  <div class="col" style="padding-right:0px">
    <button type="button" id="coupon_apply_btn" class="coupon_apply_btn">Apply</button>
  </div>
</div>`);

$('.card_fields').html(`<div class="form-row" style="margin-bottom: 12px;margin-top: 15px">
<label for="stripe-card-element">Credit or debit card</label>
<div id="stripe-card-element" style="width:100%"></div>
</div>`);
}